import React from "react";
import ReactWOW from 'react-wow';
import i18n from 'i18next'

class Prizes extends React.Component {
  render() {
    const msg = this.props.Message;
    return (
      <section id="prizes">
        <div className="container">
          <div className="title-block">
            <h2>{i18n.t(msg.prizes)}</h2>
          </div>
          <div className="prize-section">
            {
              msg.prizesData.map((item, index) => {
                return (
                  <ReactWOW animation="fadeInUp" delay="0.1s" key={index}>
                    <div className="box">
                      <img src={"images/" + item.image} className="img-fluid" alt="" />
                      <div>
                        <h4>{i18n.t(item.name)}</h4>
                        <div className="price">{i18n.t(item.price)}</div>
                      </div>
                    </div>
                  </ReactWOW>
                )
              })
            }
          </div>
        </div>
      </section>
    );
  }
}


export default Prizes;